import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';

@Component({
  selector: 'shared-filter-panel-departments',
  templateUrl: './filter-panel-departments.component.html',
  styleUrls: ['./filter-panel-departments.component.scss'],
  host: { class: 'shared-filter-panel-departments' },
})
export class SharedFilterPanelDepartmentsComponent implements OnInit {
  @Input() departments: Filter[] = [];
  @Input() selectMulti = true;
  @Output() departmentsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() { }

  allDepartments!: string[];

  ngOnInit() {
    this.loadDepartments();
  }

  getDisplayName(department: string): string {
    return department;
  }

  getValue(department: string): string {
    return department;
  }

  addProduct(department: string) {
    // if not in multi mode then clear selected.
    if (this.selectMulti === false) this.clear();

    if (!this.departments.find((sp) => sp.value === this.getValue(department))) {
      this.departments.push({
        value: this.getValue(department),
        displayName: this.getDisplayName(department),
        type: 'department',
      } as Filter);
    }
    this.departmentsChange.emit(this.departments);
  }

  removeProduct(department: string) {
    const index = this.departments.findIndex((sp) => sp.value === this.getValue(department));
    if (index > -1) {
      this.departments.splice(index, 1);
    }
    this.departmentsChange.emit(this.departments);
  }

  clear() {
    this.departments = [];
    this.departmentsChange.emit(this.departments);
  }

  isSelected(department: string): boolean {
    if (!this.departments) return false;
    if (this.departments.find((sp) => sp.value === this.getValue(department))) return true;
    else return false;
  }

  loadDepartments() {
    this.allDepartments = ['Editorial', 'Design', 'Video', 'Social', 'Consulting', 'Tech', 'AccountManagement'];
  }

}
